import React from "react";
import { Card } from "luna-react/components/card";

import { marketingPermissionsUrl } from "../../config";
import Tabs from "../common/Tabs";
import rightsGlance from "../../assets/images/tab-images/rights_glance.jpg";
import rightsContact from "../../assets/images/tab-images/rights_contact.jpg";
import manageMarketingPermissions from "../../assets/images/tab-images/manage_marketing_permissions.jpg";
import cctvUse from "../../assets/images/tab-images/cctv_use.jpg";

export const YourRights = () => {
  return (
    <Card>
      <div className="section_header center-text">
        <h1 className="section_title">Your rights</h1>
        <span className="section_subtext">
          Learn more about your data rights and how you can exercise any of your
          rights
        </span>
      </div>
      <Tabs items={tabContents} />
    </Card>
  );
};

export const tabContents = [
  {
    title: "Your Rights at a Glance",
    content: (
      <div>
        <div>
          <h6 className="m0">Access</h6>
          <div>
            You have the right to access a copy of the personal data we hold
            about you in most circumstances. This is sometimes called a ‘Subject
            Access Request’.
          </div>
        </div>
        <div className="mt1">
          <h6 className="m0">Correction of inaccurate personal data</h6>
          <div>
            You have the right to have inaccurate personal data that we hold
            about you corrected. You can always amend your details in your
            account settings or contact us to let us know what needs changing.
          </div>
        </div>
        <div className="mt1">
          <h6 className="m0">Restriction of processing</h6>
          <div>
            You have the right to request that we restrict how we process your
            personal data in certain circumstances such as if the data has been
            unlawfully processed.
          </div>
        </div>
        <div className="mt1">
          <h6 className="m0">Erasure</h6>
          <div>
            You have the right to have personal data erased. This is also known
            as the ‘right to be forgotten’. However this right is not absolute
            and only applies in certain circumstances.
          </div>
        </div>
        <div className="mt1">
          <h6 className="m0">Portability</h6>
          <div>
            You can request a copy of the personal data you have provided to us
            in a structured, commonly used and machine readable format.
          </div>
        </div>
        <div className="mt1">
          <h6 className="m0">Object</h6>
          <div>
            You have the right to object to our processing of your personal data
            based on legitimate interests and to direct marketing.
          </div>
        </div>
        <div className="mt1">
          <h6 className="m0">Automated Decision Making</h6>
          <div>
            You have the right not to be subject to a decision based solely on
            automated processing, including profiling, which has legal effects
            for you or affects you in another significant way, unless
            appropriate safeguards are in place.
          </div>
        </div>
      </div>
    ),
    image: rightsGlance,
  },
  {
    title: "Contact us or ask a question",
    content: (
      <div>
        <p>
          If you want to exercise any of your rights or ask us a question,
          please email{" "}
          <a href="mailto:privacy@sainsburys.co.uk">privacy@sainsburys.co.uk</a>{" "}
          or write to the Data Protection Officer at Privacy Team, Sainsbury's
          Supermarkets Ltd, 18th Floor, Arndale House, Manchester, M4 3AL
        </p>
        <p>
          If any of your personal data is inaccurate or out of date, please call
          the Sainsbury’s Careline on <a href="tel:0800636262">0800 63 62 62</a>{" "}
          and we’ll correct it.
        </p>
        <p>
          Before we send you a copy of your personal data or carry out a
          request, we'll need to confirm your identity. This allows us to
          protect customers' confidentiality and stop personal data falling into
          the wrong hands. To confirm who you are we may need to ask for copies
          of some identification documents, such as your passport or utility
          bills.
        </p>
        <p>
          For more information please visit{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://ico.org.uk/for-organisations/guide-to-the-general-data-protection-regulation-gdpr/individual-rights/"
          >
            https://ico.org.uk/for-organisations/guide-to-the-general-data-protection-regulation-gdpr/individual-rights/
          </a>
        </p>
      </div>
    ),
    image: rightsContact,
  },
  {
    title: "CCTV use & requests",
    content: (
      <div>
        <p>
          We use CCTV across all sites in the Sainsbury’s Group for the
          protection of our colleagues, customers and business. This includes
          investigating accidents, incidents, criminal activities and breaches
          of our policies.
        </p>
        <p>
          CCTV and ANPR cameras are also in operation in our petrol stations and
          car parks for these purposes but some of our car parks are run by
          third parties, so please check the local notice.
        </p>
        <p>
          Colleagues in some of our stores also wear body-worn cameras for
          additional protection.
        </p>
        <p>
          We keep CCTV footage on our systems for up to 31 days, it is then
          deleted. Where accidents, incidents, criminal activities or breaches
          of our policies are recorded CCTV footage may be kept for a longer
          period of time.
        </p>
        <p>
          Occasionally we share CCTV with public or regulatory authorities or in
          response to requests from individuals seeking to protect their rights
          or the rights of others. We will only share your personal information
          where appropriate.
        </p>
        <p>
          Facial Recognition Technology is also in operation in some of our
          stores. For more information please see{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            aria-label="our Facial Recognition Technology policy (opens in a new tab)"
            href="https://privacy-hub.sainsburys.co.uk/privacy-policy/#facial-recognition-technology"
          >
            our Facial Recognition Technology policy
          </a>
          .
        </p>
        <p>
          If you want to request CCTV footage of yourself from one of our
          stores, contact us at{" "}
          <a href="mailto:privacy@sainsburys.co.uk">privacy@sainsburys.co.uk</a>
        </p>
      </div>
    ),
    image: cctvUse,
  },
  {
    title: "Control your marketing permissions",
    content: (
      <div>
        <p>
          We’d love to stay in touch with you about our great products, services
          and offers. For example, we might want to tell you about a brand-new
          range or send you bonus Nectar points on products you buy.
        </p>
        <p>
          Visit our{" "}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={marketingPermissionsUrl}
          >
            Group Marketing Permissions Centre
          </a>{" "}
          where you will be able to tell us about the services that you are most
          interested in hearing about as well as letting us know that that you
          no longer want to her from us.
        </p>
      </div>
    ),
    image: manageMarketingPermissions,
  },
];

export default YourRights;



// WEBPACK FOOTER //
// ./src/components/pages/YourRights.js